const features = [
  {
    icon: 'ri-stack-line',
    title: '海量资源库',
    description: '收录超过3000部韩国漫画，涵盖恋爱、奇幻、动作、悬疑等全类型题材，每日持续更新扩充。',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: '智能推荐',
    description: '基于你的阅读偏好，精准推荐同类型优质作品，让每一次发现都充满惊喜。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    description: '全面支持手机、平板、电脑等多设备阅读，自适应排版，随时随地畅享丝滑体验。',
  },
  {
    icon: 'ri-translate-2',
    title: '高质量翻译',
    description: '专业翻译团队精心打磨每一话内容，确保语义准确、表达流畅，还原原作魅力。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速更新',
    description: '与韩国同步更新，热点新番第一时间上线，追更不再有延迟，走在漫画潮流最前沿。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    description: '纯净阅读环境，无弹窗广告、无恶意跳转，让你专注沉浸在漫画的精彩世界中。',
  },
];

export default function Features() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full border border-background-300/60 text-foreground-600 text-xs font-semibold tracking-wide mb-3">
            我们的优势
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            为什么选择韩漫网？
          </h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">
            我们致力于打造最优质的韩漫阅读平台，以用户体验为核心持续优化
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group bg-background-100 rounded-xl p-5 md:p-6 transition-all duration-300 hover:bg-primary-500 cursor-default"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-700 group-hover:bg-background-50/20 group-hover:text-background-50 transition-all duration-300 mb-4">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-background-50 transition-colors duration-300 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 group-hover:text-background-100/90 transition-colors duration-300 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}